import { Descriptions } from 'antd'
import { ModalCommon } from '../../../components'
import { IHistory } from '../../../models'
import styles from './index.module.scss'
import { find } from 'lodash'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
interface IProps {
  visible: boolean
  onOK: () => void
  onCancel: () => void
  history: IHistory
}

export const DetailLog = ({ visible, onCancel, onOK, history }: IProps) => {
  const {t} = useTranslation()
  const getTypeSync = (t: any) => [
    { name: t('logHistory.typeSync.mamaToSnappy'), value: '0' },
    { name: t('logHistory.typeSync.snappyToMama'), value: '1' },
  ]

  const getCategorySync = (t: any) => [
    { name: t('logHistory.objectMeter'), value: '0' },
    { name: t('logHistory.objectBuilding'), value: '1' },
    { name: t('logHistory.objectScan'), value: '4' },
    { name: t('logHistory.price'), value: '2' },
    { name: t('logHistory.contractor'), value: '3' },
    { name: t('logHistory.objectFormula'), value: '5' }
  ]

  const getStatus = (t: any) => [
    { name: t('logHistory.statusError'), value: '0', color: '#FF4D4F' },
    { name: t('logHistory.statusDone'), value: '1', color: '#52C41A' },
    { name: t('logHistory.statusProcessing'), value: '2', color: '#FAAD14' },
  ]

  const typeSync = getTypeSync(t)
  const categorySync = getCategorySync(t)
  const status = getStatus(t)

  return (
    <ModalCommon
      title={t('logHistory.detailLog')}
      destroyOnClose={true}
      visible={visible}
      width='60%'
      className={styles.modal}
      onOk={onOK}
      onCancel={onCancel}
    >
      <div className={styles.content}>
        <div className={styles.content__wrap}>
          <Descriptions labelStyle={{fontWeight: 900}} layout="horizontal" column={1}>
            <Descriptions.Item label={t('logHistory.direction')}>{find(typeSync, ['value', history.sync_type])?.name}</Descriptions.Item>
            <Descriptions.Item label={t('logHistory.timeStart')}>{moment(history.time_start).format('YYYY/MM/DD HH:mm')}</Descriptions.Item>
            <Descriptions.Item label={t('logHistory.object')}>{history.sync_type === '1' ? categorySync[2].name : find(categorySync, ['value', history.sync_category])?.name}</Descriptions.Item>
            <Descriptions.Item label={t('logHistory.status')} contentStyle={{color: find(status, ['value', history.status])?.color}}>{find(status, ['value', history.status])?.name}</Descriptions.Item>
            <Descriptions.Item label={t('logHistory.httpStatus')}>{history?.HTTP_STATUS}</Descriptions.Item>
            <Descriptions.Item label={t('logHistory.log')}>{!history.message && t('logHistory.noContent')}</Descriptions.Item>
          </Descriptions>
          {!!history.message && <pre className={styles.content__wrap__log} dangerouslySetInnerHTML={{__html: history.message ? JSON.stringify(history.message, null , 2) : ''}}>
          </pre>}
        </div>
      </div>
    </ModalCommon>
  )
}